import React from "react";
import { Button } from "grommet";
import { Moon, Sun } from "grommet-icons";
import { useThemeMode } from "./ThemeModeContext";

export const ThemeModeToggle = () => {
    const { themeMode, toggleThemeMode } = useThemeMode();
    const isDark = themeMode === "dark";
    return (
        <Button
            icon={isDark ? <Sun /> : <Moon />}
            onClick={toggleThemeMode}
            tip={isDark ? "Switch to light mode" : "Switch to dark mode"}
            a11yTitle={isDark ? "Switch to light mode" : "Switch to dark mode"}
        />
    );
};
